import styled, { css } from 'styled-components';
import { breakpoints } from 'theme';
import {
  schedulerTabBottomIndicatorStyles,
  SCHEDULER_TAB_ITEM_SPACING,
  SCHEDULER_TAB_ITEM_SPACING_LEGACY,
  SCHEDULER_TAB_ITEM_SPACING_MOBILE,
  SCHEDULER_TAB_PILL_PADDING,
  SCHEDULER_TAB_PILL_PADDING_MOBILE,
  SIDEBAR_SPACE_4,
  SIDEBAR_SPACE_8,
  SIDEBAR_SPACE_24,
} from 'styles/sidebarMenuListItemHighlight';

export const DocIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TabLabel = styled.span``;

export const CommentIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const tabPillSurfaceStyles = css`
  border-radius: ${SIDEBAR_SPACE_24};
  border: none;
  transition: 0.25s;

  @media ${breakpoints.smPlus} {
    padding: ${SCHEDULER_TAB_PILL_PADDING};
  }

  @media ${breakpoints.downSmPlus} {
    padding: ${SCHEDULER_TAB_PILL_PADDING_MOBILE};
  }
`;

const tabPillActiveStyles = css`
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.brightTurquoise};
  ${DocIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.white};
      }
    }
  }
  ${CommentIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.white};
      }
    }
  }
`;

export const TabPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${tabPillSurfaceStyles}

  ${({ isActive }) => isActive && tabPillActiveStyles}
`;

export const TabBottomIndicator = styled.span`
  ${schedulerTabBottomIndicatorStyles}

  @media ${breakpoints.downSmPlus} {
    width: calc(100% - ${SIDEBAR_SPACE_4} * 2);
  }
`;

export const StyledTab = styled.li`
  &:not(:last-child) {
    margin-right: ${({ isSidebar, withBottomIndicator, marginRight }) => {
      if (withBottomIndicator) {
        return SCHEDULER_TAB_ITEM_SPACING;
      }
      if (isSidebar) {
        return SIDEBAR_SPACE_4;
      }
      return marginRight || SCHEDULER_TAB_ITEM_SPACING_LEGACY;
    }};

    @media ${breakpoints.downSmPlus} {
      margin-right: ${({ isSidebar, withBottomIndicator, marginRight }) => {
        if (withBottomIndicator) {
          return SCHEDULER_TAB_ITEM_SPACING_MOBILE;
        }
        if (isSidebar) {
          return SIDEBAR_SPACE_4;
        }
        return marginRight || SCHEDULER_TAB_ITEM_SPACING_MOBILE;
      }};
    }
  }

  cursor: pointer;
  display: flex;
  flex-direction: ${({ withBottomIndicator }) =>
    withBottomIndicator ? 'column' : 'row'};
  align-items: center;
  flex-shrink: 0;
  scroll-snap-align: start;
  font-size: 14px;
  position: relative;
  color: ${({ theme }) => theme.color.baliHai};
  white-space: nowrap;

  @media ${breakpoints.downSmPlus} {
    font-size: 13px;
    line-height: 16px;
  }
  ${DocIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.baliHai};
      }
    }
  }
  ${CommentIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.baliHai};
      }
    }
  }

  ${({ withBottomIndicator }) =>
    !withBottomIndicator &&
    css`
      &:hover {
        color: ${({ theme }) => theme.color.white};
        background-color: ${({ theme }) => theme.color.brightTurquoise};
        ${DocIconWrapper} {
          & > svg {
            path {
              fill: ${({ theme }) => theme.color.white};
            }
          }
        }
        ${CommentIconWrapper} {
          & > svg {
            path {
              fill: ${({ theme }) => theme.color.white};
            }
          }
        }
      }

      border-radius: ${SIDEBAR_SPACE_24};
      border: none;

      @media ${breakpoints.smPlus} {
        padding: ${({ isSidebar }) =>
          isSidebar ? SIDEBAR_SPACE_8 : SCHEDULER_TAB_PILL_PADDING};
        margin: ${({ isSidebar }) =>
          isSidebar ? `${SIDEBAR_SPACE_4} ${SIDEBAR_SPACE_8}` : 'auto 0'};
        transition: 0.25s;
      }

      @media ${breakpoints.downSmPlus} {
        padding: ${SCHEDULER_TAB_PILL_PADDING_MOBILE};
      }

      ${({ isActive }) => isActive && tabPillActiveStyles}
    `}

  ${({ withBottomIndicator }) =>
    withBottomIndicator &&
    css`
      padding: 0;
      margin: 0;
      background: none;
      border-radius: 0;

      &:hover ${TabPill}, &:focus-visible ${TabPill} {
        ${tabPillActiveStyles}
      }

      &:hover ${TabBottomIndicator}, &:focus-visible ${TabBottomIndicator} {
        transform: scaleX(1);
      }
    `}

  ${({ withBottomIndicator, isActive }) =>
    withBottomIndicator &&
    isActive &&
    css`
      ${TabPill} {
        ${tabPillActiveStyles}
      }

      ${TabBottomIndicator} {
        transform: scaleX(1);
      }
    `}
`;

export const StyledItemPlaceholder = styled.div`
  flex-grow: 1;
`;
